import React from 'react'
import Background from './Background'

import TopBar from './TopBar'
import SiteHeader from './SiteHeader'
import SiteFooter from './SiteFooter'
import Privacy from './Privacy'

import { Space } from 'antd'

// TopBar is the house bar (standard, part 3) and spans the page, outside the column.
// SiteHeader is the game's own hero, and lives inside the column with everything else.
//
// 🔴 `style={{ display: 'flex', width: '100%' }}` ON THE SPACE IS LOAD-BEARING — 22 September
// 2026. antd's `Space` is `display: inline-flex`, and an inline-flex container SHRINKS TO ITS
// CONTENT. So the column measured 630px inside a 940px shell: the card, the table, the policy and
// the footer were all sized by whatever the board happened to need, and widening the shell to the
// family's `--container` changed nothing at all — which is why the site still looked narrow after
// that change and why George said the rules were not being followed. Making the Space a block-level
// flex container lets its items use the column, and `Play`/`Game` already pass the same override.
const SiteWrapper = ({ children }) => {
  return (
    <Background top={<TopBar />}>
      <Space direction='vertical' size='large' style={{ display: 'flex', width: '100%' }}>

        <SiteHeader />

        {children}

        <Privacy />

        <SiteFooter />

      </Space>
    </Background>
  )
}

export default SiteWrapper
